import { render, staticRenderFns } from "./list-residence.vue?vue&type=template&id=6cc41f30&scoped=true"
import script from "./list-residence.vue?vue&type=script&lang=ts"
export * from "./list-residence.vue?vue&type=script&lang=ts"
import style0 from "./list-residence.vue?vue&type=style&index=0&id=6cc41f30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc41f30",
  null
  
)

export default component.exports